import { ICurrencyModel, ICurrencyRateModel } from "./model/ICurrencyModel";
import { Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";
import { format } from "date-fns";
import { nb } from "date-fns/locale";

export default class CurrencyService extends ServiceBase {
    public async getCurrencies(
        organizationId: string,
        page?: number,
        pageSize?: number,
        freeText?: string
    ): Promise<Result<ICurrencyModel[]>> {

        let url = "/Organization/" + organizationId + "/Currency/Codes/?";

        let terms: string[] = [];

        if (page) {
            terms.push("page=" + page);
        }
        if (pageSize) {
            terms.push("pageSize=" + pageSize);
        }
        if (freeText) {
            terms.push("freeText=" + freeText);
        }

        let termsUrl = terms.join("&");

        var result = await this.requestJsonPaged<ICurrencyModel[]>({
            url: url + termsUrl,
            method: "GET"
        });
        return result;
    }

    public async getCurrencyRate(
        organizationId: string,
        codeId: number,
        date: Date
    ): Promise<Result<ICurrencyRateModel>> {

        const dateStr1 = format(new Date(date), 'yyyy-MM-dd', { locale: nb })

        const url = `/Organization/${organizationId}/Currency/Codes/${codeId}/Rate/${dateStr1}`;

        const result = await this.requestJson<ICurrencyRateModel>({
            url: url,
            method: "GET"
        });

        return result;
    }
}

